import React from "react"
import {
  // Footer as CommonFooter,
  withNotification,
} from "@omnichannel/ace-b2b-elements"
import { useMutation } from "@apollo/react-hooks"
import withApolloClient from "../components/withApolloClient"
import { BASE_URL, PROFILE_PAGE_URL } from "../helpers/constants"
import gql from "graphql-tag"
import PreFooter from "./preFooter"
import CommonFooter from "./footerCommon"
import { Spacer } from "../styles/common"

const createEmailListMutationGQL = gql`
  mutation createMailListEntryByEmailOnly($email: String) {
    createMailListEntryByEmailOnly(email: $email)
  }
`

const Footer = props => {
  const { openNotification, openErrorNotification } = props.context
  const [createEmailList, { loading }] = useMutation(
    createEmailListMutationGQL,
    {
      fetchPolicy: "no-cache",
      onCompleted: res => {
        const message = res.createMailListEntryByEmailOnly
        if (message === "Already included to newsletter") {
          openErrorNotification(message)
          return
        }
        openNotification(message)
      },
      onError: () => {
        openErrorNotification("Oops something went wrong. Please try again.")
      },
    }
  )
  return (
    <>
      <PreFooter />
      <CommonFooter
        baseUrl={BASE_URL}
        profileUrl={PROFILE_PAGE_URL}
        loading={loading}
        onClickEvent={email => {
          createEmailList({
            variables: {
              email,
            },
          })
        }}
      />
    </>
  )
}

export default withApolloClient(withNotification(Footer), {
  client: "smClient",
})
